import { useInstanceLayoutEffect } from '@/scenarios/legacy-player/hooks/useInstanceLayoutEffect';

export const useSetNativeSubtitlesVisibility = (isVisible: boolean) => {
    useInstanceLayoutEffect(
        (instance) => instance?.setNativeSubtitlesVisibility(isVisible),
        [isVisible]
    );
};
